import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import UpdateContext from '../context/update';

const DeleteRouter = () => {

    const updateContext = useContext(UpdateContext);

    const deleteReducer = useSelector(state => {
        return state.deleteReducers.delete.get;
    });

    useMemo(() => {
        if (deleteReducer.loading) {
            return null;
        } else if (deleteReducer.success.ok) {
            updateContext.updateStatusHandler();
            return message.info('Deleted Successfully!');
        } else if (deleteReducer.failure.error) {
            return message.error('Error while deleting data!');
        }
    }, [deleteReducer.success.ok]);

    return null;
};

export default DeleteRouter;